import Vue from 'vue';
import VueI18n from 'vue-i18n'
import App from './App.vue';
import store from './store';
import router from './router';
import request from './tools/request';
import 'jquery';
import ElementUI from 'element-ui';
import '@/assets/style/element-variables.scss';
import locale from 'element-ui/lib/locale';
import en from 'element-ui/lib/locale/lang/en'
import cn from 'element-ui/lib/locale/lang/zh-CN'
import {setUnit} from "./tools";
import {Toast, Dialog} from 'vant';
import '@vant/touch-emulator';
import '@/assets/style/font.css';
import animated from 'animate.css';
import * as echarts from 'echarts/core';
import {TitleComponent, ToolboxComponent, TooltipComponent, GridComponent, LegendComponent} from 'echarts/components';
import { LineChart } from 'echarts/charts';
import { UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';

Vue.config.productionTip = false;
Vue.prototype.setUnit = setUnit;
Vue.prototype.$http = request;

Vue.use(VueI18n);
Vue.use(ElementUI);

const messages = {
    en: {
        message: 'hello',
        ...en // 或者用 Object.assign({ message: 'hello' }, enLocale)
    },
    cn: {
        message: '你好',
        ...cn // 或者用 Object.assign({ message: '你好' }, zhLocale)
    }
}

const i18n = new VueI18n({
    locale: 'cn', // set locale
    messages, // set locale messages
})

locale.i18n((key, value) => i18n.t(key, value));

Vue.use(Toast).use(Dialog);
Vue.use(animated);

echarts.use([TitleComponent, ToolboxComponent, TooltipComponent, GridComponent, LegendComponent, LineChart, CanvasRenderer, UniversalTransition]);
Vue.use(echarts);

new Vue({
    i18n,
    store,
    router,
    render: h => h(App)
}).$mount('#app');

